/**
 * Function that opens the `actionUrl` of a notification in the same window.
 *
 * @param notification The notification
 */
export function openActionUrl(notification) {
    if (notification.actionUrl)
        window.open(notification.actionUrl, '_self');
}
//# sourceMappingURL=eventHandlers.js.map